import { render } from "./AuthForm.vue?vue&type=template&id=1f44c52c&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=1f44c52c&lang=scss&scoped=true"

import exportComponent from "D:\\ProjectsWeb\\road-maintenance-launcher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f44c52c"]])

export default __exports__